import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { RichTalking } from "@/components/RichTalking";

export default function AuthorSection() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);
  const imageY = useTransform(scrollYProgress, [0, 1], [0, -80]);

  return (
    <section ref={ref} className="relative bg-[#FAF7F2] py-28 md:py-40 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <RichTalking />
        <div className="grid grid-cols-12 gap-y-12 gap-x-8">
          <div className="col-span-12 md:col-span-5 relative">
            <div className="relative aspect-[3/4] overflow-hidden border border-[#E7DFD5] bg-black">
              <motion.img
                style={{ y: imageY, scale: 1.12 }}
                src="/author/avatar.jpg"
                alt="Rich Culmer — creator of T.A.C.C."
                data-testid="healer-portrait"
                className="absolute inset-0 w-full h-full object-cover object-top contrast-[1.05]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="section-tag mb-2">The Healer</div>
                <div className="font-display text-2xl md:text-3xl">Rich Culmer.</div>
                <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#B45309] mt-1">10 years · 3 books · 8 modules · 1 formula</div>
              </div>
            </div>
          </div>

          <motion.div
            style={{ y }}
            className="col-span-12 md:col-span-6 md:col-start-7 flex flex-col justify-center"
          >
            <div className="section-tag mb-6">§ Meet the Healer</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight mb-8">
              Ten years of studying what <span className="italic text-[#B45309]">breaks</span> workers — and what brings them back.
            </h2>
            <div className="space-y-5 text-[#78716C] text-lg leading-relaxed max-w-xl" data-testid="healer-story">
              <p>
                T.A.C.C. began as a private notebook — a set of pre-shift rituals a worker used to survive a job they no longer recognized. Over a decade, that notebook became a formula: studied, tested on real shifts, broken, and rebuilt until it held.
              </p>
              <p>
                Rich Culmer spent those ten years developing the T.A.C.C. method — Through Adversity Comes Change — turning lived experience into three books, eight narrated modules, and a corporate wellness practice for companies that stopped pretending their people were fine.
              </p>
              <p>
                The formula wasn&apos;t built in a classroom. It was built on the worst mornings — and refined until it worked on them.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
